import { Grid, Paper, Skeleton } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    skeletonPaper: {
      width: '100%',
      padding: 16,
      borderRadius: 6,
      backgroundColor: '#1c2028',
      border: '1px solid rgba(92, 107, 192, 0.15)',
      borderLeft: '3px solid rgba(92, 107, 192, 0.3)',
      marginBottom: 12,
    },
    skeletonKeywords: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

const SKELETON_BASE = 'rgba(92, 107, 192, 0.08)';
const SKELETON_HIGHLIGHT = 'rgba(92, 107, 192, 0.15)';

export default function SearchResultsSkeleton() {
  const classes = useStyles();

  const RoundedSkeleton = (props) => (
    <Skeleton
      {...props}
      variant="rectangular"
      height={40}
      width={props.i * 40}
      sx={{
        borderRadius: '20px',
        backgroundColor: SKELETON_BASE,
        '&::after': {
          background: `linear-gradient(90deg, transparent, ${SKELETON_HIGHLIGHT}, transparent)`,
        },
      }}
    />
  );

  return (
    <>
      {Array.from(Array(10)).map((field, i) => (
        <Paper className={classes.skeletonPaper} elevation={0} key={i}>
          <Grid container style={{ width: '100%' }}>
            <Grid item sm={12}>
              <Skeleton
                variant={'text'}
                height={20}
                sx={{ maxWidth: 250, backgroundColor: SKELETON_BASE }}
              />
            </Grid>
            <Grid container item sm={12}>
              <Grid sm={6}>
                <Skeleton
                  variant={'text'}
                  height={20}
                  sx={{ maxWidth: 280, backgroundColor: SKELETON_BASE }}
                />
              </Grid>
              <Grid sm={6}>
                <Skeleton
                  variant={'text'}
                  height={20}
                  sx={{ maxWidth: 120, backgroundColor: SKELETON_BASE }}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} style={{ marginBottom: 8 }}>
                <Skeleton
                  variant={'text'}
                  height={20}
                  sx={{ maxWidth: 100, backgroundColor: SKELETON_BASE }}
                />
              </Grid>
              {Array.from(Array(6)).map((field, i) => (
                <Grid item xs={12} sm={6} style={{ padding: 2 }} key={i + 7}>
                  <RoundedSkeleton i={Math.ceil((i + 2) * Math.random())} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  );
}
